// extracted by mini-css-extract-plugin
export default {"label":"styles_label__nVmIu","error":"styles_error__kpSk0","errorMessage":"styles_errorMessage__tSbOx"};